export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-slide-nav/index.js